import React from 'react'

export const FacebookIcon = ({ fill }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='10' height='20' viewBox='0 0 10 20'>
      <path id='Path_695' data-name='Path 695' d='M1745.82,441v-9h2.73l.45-4h-3.18v-1.948c0-1.03.03-2.052,1.47-2.052h1.45v-2.86a16.034,16.034,0,0,0-2.51-.14c-2.65,0-4.31,1.657-4.31,4.7V428H1739v4h2.92v9Z' transform='translate(-1739 -421)' fill={fill} />
    </svg>
  )
}
